import { UIText1, UIText3 } from '@cian/ui-kit';
import { IconProductDocumentsVerified16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import * as style from './style.css';

export interface IAgentProofsTitleProps {
  title: string;
  size?: 'small' | 'medium';
}

export const AgentProofsTitle: React.FC<React.PropsWithChildren<IAgentProofsTitleProps>> = ({
  title,
  size = 'small',
}) => {
  return (
    <div className={style['agent-proofs-title']}>
      <IconProductDocumentsVerified16 color="icon-main-default" />
      {size === 'medium' && <UIText1>{title}</UIText1>}
      {size === 'small' && <UIText3>{title}</UIText3>}
    </div>
  );
};
